import { render } from "./PurchaseInfosModal.vue?vue&type=template&id=1c1046b8&scoped=true&ts=true&lang=pug"
import script from "./PurchaseInfosModal.vue?vue&type=script&lang=ts"
export * from "./PurchaseInfosModal.vue?vue&type=script&lang=ts"

import "./PurchaseInfosModal.vue?vue&type=style&index=0&id=1c1046b8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1046b8"]])

export default __exports__